import { ContentSwitcher as UIContentSwitcher } from "@webmotors/eleanor-ui";

interface Item {
  name: string;
  value: string;
  selected: boolean;
  Icon?: React.ReactNode;
  dataTestId: string;
}

export type Token =
  | 'default'
  | 'primary'
  | 'success'
  | 'informative'
  | 'complementary'
  | 'situational';

export interface ContentSwitcherProps {
  items?: Item[];
  disabled?: boolean;
  token?: Token;
  onClick?: (index?: string) => void;
  className?: string;
}

export function ContentSwitcher({
  items = [],
  disabled = false,
  token = 'default',
  className,
  onClick,
  ...props
}: Readonly<ContentSwitcherProps>) {
    return (
        <UIContentSwitcher
            className={className}
            items={items}
            token={token}
            onClick={onClick}
            disabled={disabled}
            {...props}
        />
    ); 
};